import API from './Api';

class GradeLevelsAPI extends API {
  constructor() {
    super('/grade-levels');
  }

}

export default GradeLevelsAPI;